export default __webpack_public_path__ + "static/media/ROVER.3f9da703.jpg";